import { Resource as e } from "@coveo/platform-client";
// src/resources/BackendOnlyResource.ts
var t = class extends e {
	constructor(e, t, n) {
		super(e, t), this.internalAPI = n;
	}
};
export { t as BackendOnlyResource };

//# sourceMappingURL=BackendOnlyResource.js.map